/** Kamus **panggilan tamu** (§11) — layar pelayan. */
export const guestCallId = {
  title: 'Panggilan tamu',
  empty: 'Tidak ada panggilan',
  waiter: 'Panggil pelayan',
  bill: 'Minta bill',
  /** ⭐ Menit lebih berguna dari jam: yang menentukan urutan adalah "sudah menunggu berapa lama". */
  waiting: 'menunggu {{n}} dtk',
  waitingMinutes: 'menunggu {{n}} mnt',
  accept: 'Saya datangi',
  /** ⚠️ "Bukan tamu", bukan "spam" — pelayan menilai yang DILIHATNYA, bukan menuduh niat. */
  notGuest: 'Bukan tamu',
  suspended: 'QR meja {{table}} ditangguhkan sementara',
  allAreas: 'Semua area',
  /** ⚠️ Bunyi harus dinyalakan lewat SENTUHAN — browser HP menolak audio tanpa gestur pengguna. */
  enableSound: '🔕 Ketuk untuk nyalakan bunyi',
  soundOn: '🔔 Bunyi aktif',
  loadFailed: 'Daftar panggilan gagal dimuat',
  /* ⚠️ Disebut apa adanya: pelayan perlu tahu layarnya sedang lambat, bukan sekadar "ada masalah". */
  degraded: 'Sambungan langsung terputus — daftar disegarkan berkala, bisa telat beberapa detik',
};

export const guestCallEn: typeof guestCallId = {
  title: 'Guest calls',
  empty: 'No calls',
  waiter: 'Call a waiter',
  bill: 'Ask for the bill',
  waiting: 'waiting {{n}}s',
  waitingMinutes: 'waiting {{n}}m',
  accept: "I'll go",
  notGuest: 'Not a guest',
  suspended: 'QR for table {{table}} temporarily suspended',
  allAreas: 'All areas',
  enableSound: '🔕 Tap to enable sound',
  soundOn: '🔔 Sound on',
  loadFailed: 'Could not load calls',
  degraded: 'Live connection lost — refreshing periodically, may lag by seconds',
};
